export default "__VITE_ASSET__BJCcfwU5__"